var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIconSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.66634C12 3.29815 11.7015 2.99967 11.3333 2.99967H3.33333C2.96514 2.99967 2.66667 3.29815 2.66667 3.66634V12.9997C2.66667 13.3679 2.96514 13.6663 3.33333 13.6663H11.3333C11.7015 13.6663 12 13.3679 12 12.9997V3.66634ZM4 12.333H10.6667V4.33301H4V12.333Z",
    fill: "#567AE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 0.666341C9.33333 0.482246 9.1841 0.333008 9 0.333008H0.666667C0.298477 0.333008 0 0.631485 0 0.999674V10.6663C0 10.8504 0.149238 10.9997 0.333333 10.9997H1C1.18409 10.9997 1.33333 10.8504 1.33333 10.6663V1.66634H9C9.1841 1.66634 9.33333 1.5171 9.33333 1.33301V0.666341Z",
    fill: "#567AE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIconSecond);
export default __webpack_public_path__ + "static/media/copyIconSecond.a6919954.svg";
export { ForwardRef as ReactComponent };